import { useEffect } from "react";

export default () => {
  useEffect(() => {
    window.ReactNativeWebView.postMessage(JSON.stringify({ twoFactorSuccess: false }));
  }, []);

  return <div style={{ width: "100%", height: "100%" }}></div>;
};
